export const GLOBAL_STATE = 'UserSessions' as const

export const USER_SESSIONS = 'USER_SESSIONS' as const
export const USER_SESSION_LOGOUT = 'USER_SESSION_LOGOUT' as const
export const USER_SESSIONS_LOGOUT_ALL = 'USER_SESSIONS_LOGOUT_ALL' as const
